import React, { useEffect } from "react";
import Footer from "../../shared/Footer/Footer";
import Navbar from "../../shared/Navbar/Navbar";
import MoitriChakma from "../../../images/Photos/Moitri Chakmaa.jpg";
import MangalManiChakma from "../../../images/Photos/Mangal Mani Chakmaa.jpg";
import PalashKusumChakma from "../../../images/Photos/Palash-kusum-chakma.jpg";
import SushovanChakma from "../../../images/Photos/Sushovan Chakmaa.JPG";
import ShibaliSantiChakma from "../../../images/Photos/Shibali Shanti Chakmaa.jpg";
import AratiChakma from "../../../images/Photos/Arati Chakmaa.jpg";
import RatnaSurja from "../../../images/Photos/Ratna Surja Chakma.jpg";
import "../../../style/about/executiveCouncil.css";
import Zoom from "react-reveal/Zoom";
import TranslateButton from "../../TranslateButton/TranslateButton";
import {
  FacebookIcon,
  FacebookShareButton,
  TwitterShareButton,
  TwitterIcon,
  LinkedinShareButton,
  LinkedinIcon,
} from "react-share";

const ExecutiveCouncil = () => {
  useEffect(() => {
    document.title = `Development Concern | Executive Council`;
  }, []);

  // const shareUrl = "https://developmentconcerncht.org/about/executive-council";

  return (
    <>
      <Navbar />
      {/* <TranslateButton /> */}

      <div className="executive_council_section">
        <div className="header_image">
          <p>Home | About</p>
          <h2>Executive Council</h2>
        </div>

        {/* Header Background Part Start */}
        {/* <div className="header_background">
          <div className="container wrapper">
            <h2> Executive Council </h2>
            <div className="social_share_button">
              <FacebookShareButton
                url={shareUrl}
                target={"_blank"}
                quote={"share facebook"}
                hashtag={"#facebook"}
              >
                <FacebookIcon size={35} round={true} />
              </FacebookShareButton>
              <TwitterShareButton
                url={shareUrl}
                target={"_blank"}
                quote={"share twitter"}
                hashtag={"#twitter"}
              >
                <TwitterIcon size={35} round={true} />
              </TwitterShareButton>
              <LinkedinShareButton
                url={shareUrl}
                target={"_blank"}
                quote={"share linkedin"}
                hashtag={"#linkedin"}
              >
                <LinkedinIcon size={35} round={true} />
              </LinkedinShareButton>
            </div>
          </div>
        </div> */}
        {/* Header Background Part End */}

        <div className="container">
          <h1>Executive Council</h1>
          <p className="title_heading">
            The EC is elected by the general council members in an election and/or selection process in its Annual General Meeting for a period of 3 years term. The Executive Council is consisting of 7 members where 4 members are men and 3 members are women; and headed by a president. The executive Council is responsible for the overall management aspect of the organization. The Executive Council prepares annual report as regards the overall performance of the organization and report to the General Council members. The Executive council meets at least 3 times in a year. This council can meet on emergency basis at any time in the year as and when required. The problems and issues as regard the ongoing program activities are discussed in these meetings and necessary recommendations are made to solve operational of the organization and project implementation.
          </p>

          <div className="top_image">
            <Zoom duration={3000}>
              <div className="single_content_wrapper">
                <img src={MoitriChakma} alt="" />
                <div className="title_wrapper">
                  <h4>Ms. Moitri Chakma</h4>
                  <p>Chairperson</p>
                </div>
              </div>
            </Zoom>
          </div>

          <div className="content_wrapper">
            <Zoom duration={3000}>
              <div className="single_content_wrapper">
                <img src={MangalManiChakma} alt="" />
                <div className="title_wrapper">
                  <h4>Mr. Mangal Moni Chakma</h4>
                  <p>Vice-Chairperson</p>
                </div>
              </div>
            </Zoom>

            <Zoom duration={3000}>
              <div className="single_content_wrapper">
                <img src={PalashKusumChakma} alt="" />
                <div className="title_wrapper">
                  <h4>Mr. Palash Kusum Chakma</h4>
                  <p>General Secretary</p>
                </div>
              </div>
            </Zoom>

            <Zoom duration={3000}>
              <div className="single_content_wrapper">
                <img src={SushovanChakma} alt="" />
                <div className="title_wrapper">
                  <h4>Mr. Sushovan Chakma</h4>
                  <p>Vice-General Secretary</p>
                </div>
              </div>
            </Zoom>

            <Zoom duration={3000}>
              <div className="single_content_wrapper">
                <img src={ShibaliSantiChakma} alt="" />
                <div className="title_wrapper">
                  <h4>Mr. Shibali Santi Chakma</h4>
                  <p>Treasurer</p>
                </div>
              </div>
            </Zoom>

            <Zoom duration={3000}>
              <div className="single_content_wrapper">
                <img src={AratiChakma} alt="" />
                <div className="title_wrapper">
                  <h4>Mr. Arati Chakma</h4>
                  <p>Executive Member </p>
                </div>
              </div>
            </Zoom>

            <Zoom duration={3000}>
              <div className="single_content_wrapper">
                <img src={RatnaSurja} alt="" />
                <div className="title_wrapper">
                  <h4>Mr. Ratna Surja Chakma</h4>
                  <p>Executive Member</p>
                </div>
              </div>
            </Zoom>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ExecutiveCouncil;
